export default {
  AppName: 'Badpa',
  AppTagline: 'Admin dashboard'
}
